<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <EventHeader :event="event" />
        <span class="title"
          >Manage Spectators - Total: {{ entries.length }}</span
        >
        <b-button
          type="is-primary"
          class="is-pulled-right"
          @click="exportSpectators"
          >Export</b-button
        >
        <b-input
          v-if="entries.length > 0"
          v-model="search"
          class="has-margin-top-15"
          icon="magnify"
          :expanded="true"
          placeholder="Search ..."
        />
        <b-table
          class="has-margin-top-15"
          :data="filteredEntries"
          :narrowed="true"
          :hoverable="true"
          :mobile-cards="true"
        >
          <template slot-scope="props">
            <b-table-column
              label="Name"
              field="firstname"
              :sortable="true"
              width="200"
            >
              {{ props.row.name }}
            </b-table-column>
            <b-table-column label="Email" field="email" :sortable="true">
              {{ props.row.email }}
            </b-table-column>
            <b-table-column
              label="Contact No"
              field="contactno"
              :sortable="true"
            >
              {{ props.row.contactno }}
            </b-table-column>
            <b-table-column label="Guest" field="guest" :sortable="true">
              {{ props.row.guest ? 'Yes' : '' }}
            </b-table-column>
          </template>
        </b-table>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventHeader from '@/components/EventHeader'
import CardComponent from '@/components/CardComponent'
import SpectatorApi from '@/api/spectator'
import Filters from '@/mixins/filters'

export default {
  name: 'ManageSpectators',
  components: {
    CardComponent,
    EventHeader,
  },
  mixins: [Filters],
  data() {
    return {
      entries: [],
      search: '',
      initialized: false,
    }
  },
  computed: {
    ...mapGetters(['event']),
    filteredEntries() {
      if (this.entries.length > 0 && this.search !== '') {
        let search = this.search.toLowerCase()
        return this.entries.filter((entry) => {
          return (
            entry.firstname.toLowerCase().includes(search) ||
            entry.surname.toLowerCase().includes(search) ||
            (entry.email && entry.email.toLowerCase().includes(search))
          )
        })
      }
      return this.entries
    },
  },
  async created() {
    let entries = await SpectatorApi.getAll(this.$route.params.eventid)
    entries.forEach((entry) => {
      entry.userId = entry.user._id
      entry.name = entry.guest
        ? `${entry.firstname} ${entry.surname} (${entry.user.firstname} ${entry.user.surname})`
        : `${entry.user.firstname} ${entry.user.surname}`
      entry.email = entry.user.email
      entry.contactno = entry.user.contactno
    })
    this.entries = entries
    this.initialized = true
  },
  methods: {
    async exportSpectators() {
      await SpectatorApi.export(this.$route.params.eventid)
    },
  },
}
</script>

<style scoped>
td {
  font-size: 0.85em;
}
</style>
